(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cookie-consent"] && !Shopify.designMode) return;
  try {
    (function () {
    const STORAGE_KEY = 'pump_cookie_consent';
    const banner = document.querySelector('[data-cookie-consent]');
    if (!banner) return;

    if (localStorage.getItem(STORAGE_KEY)) return;

    function syncStickyOffset() {
      const sticky = document.querySelector('[data-sticky-atc].is-visible');
      document.documentElement.style.setProperty('--sticky-atc-offset', sticky ? '72px' : '0px');
    }

    banner.hidden = false;
    syncStickyOffset();
    window.addEventListener('scroll', syncStickyOffset, { passive: true });

    const acceptBtn = banner.querySelector('[data-cookie-accept]');
    acceptBtn?.focus();

    function setConsent(accepted) {
      localStorage.setItem(STORAGE_KEY, accepted ? 'accepted' : 'rejected');
      banner.hidden = true;
      if (window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.setTrackingConsent === 'function') {
        window.Shopify.customerPrivacy.setTrackingConsent(accepted, function () {});
      }
    }

    banner.querySelector('[data-cookie-accept]')?.addEventListener('click', function () {
      setConsent(true);
    });

    banner.querySelector('[data-cookie-reject]')?.addEventListener('click', function () {
      setConsent(false);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["localization-form"] && !Shopify.designMode) return;
  try {
    (function () {
    function closeGroup(group) {
      if (!group) return;
      var trigger = group.querySelector('[data-pp-loc-trigger]');
      var menu = group.querySelector('[data-pp-loc-menu]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      if (menu) menu.hidden = true;
    }

    function closeAll(except) {
      document.querySelectorAll('[data-pp-loc-group]').forEach(function (group) {
        if (group !== except) closeGroup(group);
      });
    }

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-pp-loc-trigger]');
      if (trigger) {
        var group = trigger.closest('[data-pp-loc-group]');
        var menu = group && group.querySelector('[data-pp-loc-menu]');
        if (!group || !menu) return;

        var willOpen = trigger.getAttribute('aria-expanded') !== 'true';
        closeAll(willOpen ? group : null);
        trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        menu.hidden = !willOpen;
        return;
      }

      var option = event.target.closest('[data-pp-loc-option]');
      if (option) {
        var group = option.closest('[data-pp-loc-group]');
        var select = group && group.querySelector('[data-pp-loc-select]');
        var label = group && group.querySelector('[data-pp-loc-label]');
        var form = option.closest('form');
        if (!select || !form) return;

        var value = option.getAttribute('data-value');
        select.value = value;

        group.querySelectorAll('[data-pp-loc-option]').forEach(function (btn) {
          var active = btn === option;
          btn.classList.toggle('is-active', active);
          btn.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        if (label) {
          var name = option.querySelector('.pp-loc__option-name');
          var currency = option.querySelector('.pp-loc__option-currency');
          label.textContent = currency
            ? name.textContent + ' | ' + currency.textContent
            : name.textContent;
        }

        closeGroup(group);
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
        } else {
          form.submit();
        }
        return;
      }

      if (!event.target.closest('[data-pp-loc-group]')) {
        closeAll(null);
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeAll(null);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
